import { useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { Add, AdminPanelSettingsOutlined } from "@mui/icons-material";
import MDSnackbar from "shared/components/MDSnackbar";
import RoleDialog from "../Form/RoleDialog";
import { createRolService } from "modules/rol/services/rolService";

function HeaderRol({ children, onRolCreated }) {
  const [openModal, setOpenModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const handleSubmitRol = async (data) => {
    await createRolService(data);
    setOpenModal(false);
    setSuccess(true);
    onRolCreated?.();
  };
  return (
    <Box>
      <Box
        sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          borderRadius: 3,
          background: "linear-gradient(135deg, #1e293b, #0b4f6c)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <AdminPanelSettingsOutlined sx={{ color: "#fff", fontSize: 30 }} />
          <Box>
            <Typography variant="h5" sx={{ color: "#fff", fontWeight: 700 }}>
              Roles y permisos
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
              Administre los accesos del sistema por módulo.
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setOpenModal(true)}
          sx={{ bgcolor: "#fff", color: "#1e293b", "&:hover": { bgcolor: "#eef2f6" } }}
        >
          Crear rol
        </Button>
      </Box>
      {children}
      <RoleDialog open={openModal} onClose={() => setOpenModal(false)} onSubmit={handleSubmitRol} />
      <MDSnackbar
        color="success"
        icon="check"
        title="Rol creado"
        content="El rol se creó correctamente."
        dateTime="Ahora"
        open={success}
        onClose={() => setSuccess(false)}
        close={() => setSuccess(false)}
        bgWhite
      />
    </Box>
  );
}
HeaderRol.defaultProps = { children: null, onRolCreated: null };
HeaderRol.propTypes = { children: PropTypes.node, onRolCreated: PropTypes.func };
export default HeaderRol;
